import { render } from "./citation-search-results.vue?vue&type=template&id=e2cdae76&ts=true"
import script from "./citation-search-results.vue?vue&type=script&lang=ts"
export * from "./citation-search-results.vue?vue&type=script&lang=ts"

import "./citation-search-results.vue?vue&type=style&index=0&id=e2cdae76&lang=css"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__